import React from 'react';

const ErrorMessage = () => {
    return (
        <div className="error-msg ">
            <h5>No records to display</h5>
        </div>
    );
};

export default ErrorMessage;